import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RegContainer } from '../components/Authentication/AuthStyles';
import { useSelector } from 'react-redux';

const OrderComplete = () => {
    let navigate = useNavigate();
    const resetReducer = useSelector((state) => state.resetReducer);
    const { resetUser } = resetReducer;

    useEffect(() => {
        if (resetUser) {
            navigate(`/dashboard`);
        }
    }, [resetUser, navigate]);

    return (
        <RegContainer>
            <h1>Orer Complete</h1>
        </RegContainer>
    );
};

export default OrderComplete;
